// extracted by mini-css-extract-plugin
module.exports = {"rootWithDiscount":"_1TuAD","root":"-DeRq","originalPrice":"_13blh","promoPrice":"tf4fk"};